import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Dayjs } from 'dayjs';
import { map, Observable } from 'rxjs';
import {
  LeaderBoardCoachDTO,
  LeaderBoardCoachEntryDTO,
  LeaderBoardDTO,
} from '../components/organisms/leader-board/leader-board.types';
import { ApiRoutes } from '../constants/api-routes.constants';
import { UsersResponseDTO } from '../types/user.types';
import { createEndpointUrl } from '../utilities/pure-functions';

@Injectable({
  providedIn: 'root',
})
export class CheckInService {
  private readonly http = inject(HttpClient);

  public createCheckIn(activityId: string, checkInCode: string): Observable<void> {
    const url = createEndpointUrl(ApiRoutes.checkInById, { id: activityId });

    return this.http.post<void>(url, { checkInCode }, { headers: { addAuthHeader: 'true' } });
  }

  public createManualCheckIn(
    userIds: string[],
    activityId: string,
    checkInCode: string
  ): Observable<void> {
    const url = createEndpointUrl(ApiRoutes.checkInManuallyById);
    return this.http.post<void>(
      url,
      { activityId, checkInCode, userIds },
      { headers: { addAuthHeader: 'true' } }
    );
  }

  public deleteCheckIn(activityId: string): Observable<void> {
    const url = createEndpointUrl(ApiRoutes.checkInById, { id: activityId });

    return this.http.delete<void>(url, { headers: { addAuthHeader: 'true' } });
  }

  public getCheckInRanking(): Observable<LeaderBoardDTO> {
    const url = createEndpointUrl(ApiRoutes.checkInRanking);

    return this.http.get<LeaderBoardDTO>(url, { headers: { addAuthHeader: 'true' } });
  }

  public getLeaderBoardCoach(start: Dayjs, end: Dayjs): Observable<LeaderBoardCoachEntryDTO[]> {
    const url = createEndpointUrl(ApiRoutes.getCoachLeaderBoard);

    const params = new HttpParams()
      .append('start', start.format('YYYY-MM-DD'))
      .append('end', end.format('YYYY-MM-DD'));

    return this.http
      .get<LeaderBoardCoachDTO>(url, {
        params,
        headers: { addAuthHeader: 'true' },
      })
      .pipe(map((response) => response.payload.leaderBoard.map((item) => item)));
  }

  public getAllCheckInsByActivityId(activityId: string): Observable<UsersResponseDTO> {
    const url = createEndpointUrl(ApiRoutes.getAllCheckInsByActivityId);

    const params = new HttpParams().append('activityId', activityId);

    return this.http.get<UsersResponseDTO>(url, { params, headers: { addAuthHeader: 'true' } });
  }

  public triggerCheckInDataExport(start: Dayjs, end: Dayjs): Observable<void> {
    const url = createEndpointUrl(ApiRoutes.checkInDataExport);

    const params = new HttpParams()
      .append('start', start.format('YYYY-MM-DD'))
      .append('end', end.format('YYYY-MM-DD'));

    return this.http.get<void>(url, { params, headers: { addAuthHeader: 'true' } });
  }
}
